import React from 'react';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { generateTimeSlots } from '../../../utils/calendar/calendarHelpers';
import { CALENDAR_CONSTANTS } from '../../../utils/calendar/constants';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

/**
 * TimeGrid component - renders ONLY the time labels
 * Grid lines are handled by CalendarGrid to avoid double lines
 */
const TimeGrid = ({
                      timeRange,
                      hourHeight = CALENDAR_CONSTANTS.HOUR_HEIGHT,
                  }) => {
    const { earliestTime, latestTime } = timeRange;

    // Generate time slots for display - one slot per hour
    const timeSlots = generateTimeSlots(earliestTime, latestTime, 60);
    const totalHeight = timeSlots.length * hourHeight;

    return (
        <div className="time-column" style={{ height: `${totalHeight + 80}px` }}>
            {/* Header spacer - matches existing 80px height */}
            <div className="time-slot-label time-header-spacer"></div>

            {/* Time labels - NO borders, just labels */}
            {timeSlots.map((time, index) => (
                <div
                    key={time}
                    className="time-slot-label"
                    style={{
                        position: 'absolute',
                        top: `${80 + (index * hourHeight)}px`,
                        left: '0',
                        right: '0',
                        height: `${hourHeight}px`,
                        // EXPLICITLY remove any borders that might be added by CSS
                        border: 'none',
                        borderBottom: 'none',
                        borderTop: 'none',
                    }}
                >
                    {time}
                </div>
            ))}
        </div>
    );
};

export default TimeGrid;